<div class="dashboard-add-dialog-component">
  <h2 mat-dialog-title>{{ 'DASHBOARDPANEL.DIALOG-TITLE.ADD' | transloco }}</h2>

  <div mat-dialog-content>
    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step [stepControl]="editChild?.form">
        <ng-template matStepLabel>{{
          'DASHBOARDPANEL.DIALOG-TITLE.CREATE' | transloco
        }}</ng-template>

        <ng-template matStepContent>
          <dashboard-dashboard-edit
            #editChild
            [dashboard]="dashboard"
          ></dashboard-dashboard-edit>
        </ng-template>
      </mat-step>
      <mat-step [editable]="">
        <ng-template matStepLabel>{{
          'DASHBOARDPANEL.DIALOG-TITLE.REFERENCE' | transloco
        }}</ng-template>

        <ng-template matStepContent>
          <dashboard-dashboard-reference #referenceChild>
          </dashboard-dashboard-reference>
        </ng-template>
      </mat-step>
    </mat-horizontal-stepper>
  </div>

  <div mat-dialog-actions align="end">
    <cc-cancel-action-button (onClick)="close()"></cc-cancel-action-button>
    <cc-save-action-button
      [disabled]="!editChild?.form || editChild.form.invalid"
      (onClick)="save()"
    ></cc-save-action-button>
  </div>
</div>
